<script setup lang="ts">
import { computed } from 'vue'
import Dropdown from 'primevue/dropdown'
import InputText from 'primevue/inputtext'

const props = defineProps<{
  modelValue?: number,
  disabled?: boolean
}>()

const emit = defineEmits(['update:modelValue'])

const value = computed({
  get: () => props.modelValue ?? 0,
  set: (newVal?: number) => emit('update:modelValue', newVal)
})

const options = [
  { value: 0, label: 'Pending' },
  { value: 1, label: 'Passed' },
  { value: 2, label: 'Quarantine' }
]

const getStatus = (status: any) => {
  switch (status) {
    case 0:
      return 'Pending'
    case 1:
      return 'Passed'
    case 2:
      return 'Quarantine'
    default:
      return ''
  }
}
</script>

<template>
  <div class="flex flex-col gap-2">
    <label for="qualityCheckStatus">Status:</label>
    <InputText v-if="disabled" :value="getStatus(value)" :disabled="disabled" />

    <Dropdown
      v-else
      id="qualityCheckStatus"
      v-model="value"
      :options="options"
      option-label="label"
      option-value="value"
      placeholder="Select status from drop down"
      panel-class="capitalize"
    />
  </div>
</template>